<template>
  <div class="form-div main-margin-div">
    <div class="title" style="text-align: center;height: 100px">
      <h1>{{tittle}}</h1>
      <span><a v-if="remark!='0'" href="javascript:void(0);" class="el-icon-shopping-cart-2" @click="changeLove">&nbsp;{{isCollect=='1'?'已收藏':'收藏'}}</a></span>
    </div>
    <div id="content" class="content_div" :style="screenHeight">
      <!--      <div v-html="content"></div>-->
      <div class='parent' id='parent'></div>
    </div>
    <div class="file_list_div">
      <div class="files" style="padding-top: 20px;" v-for="(item , index) in uploadList" :key="index" :id="item.id">
        <a :href="item.fileUrl" target="_blank">{{item.showName}}</a>
        <p style="padding-top: 10px;">{{item.description}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import Vue from 'vue'

  export default {
    name: "ViewknowContent",
    props: {
      knowLookId: String
    },
    mixins: [publicFunClass],
    data() {
      return {
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        uploadList: [],
        fileUrl: '',
        downName: '',
        isCollect: '',
        isOpen: '',
        tittle: '',
        fileAddr: '',
        description: '',
        content: '',
        spinShow: true,
        selected: true,
        showMessage: false,
        screenHeight: {height: ''},
        remark: '',
        srcList: [],
      }
    },
    methods: {
      changeLove: function () {
        let that = this;
        let journalType = "知识库内容收藏";
        if ("0" == this.isCollect) {
          this.isCollect = "1";
        } else {
          this.isCollect = "0";
          journalType = "知识库内容取消收藏";
        }
        let param = {
          id: this.knowLookId,
          type: this.isCollect,
          journalType: journalType,
          menuId: "null"
        };
        this.$http.post("knowledge/doCollectors.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
        });
      },
      showBigPicture: function () {
        alert("123");
      },
      initSearch: function () {
        let that = this;
        let param = {
          id: this.knowLookId,
          journalType: "null",
          menuId: "null"
        };
        this.$http.post("knowledge/selectOne.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let addressList = res.data.obj.fileAddrs;
          if (addressList != null) {
            for (let i = 0; i < addressList.length; i++) {
              let param = {
                showName: addressList[i].showName,
                fileUrl: that.baseURL + "common/downloadFile.json?type=0&addr=" + addressList[i].downName,
                description: addressList[i].description,
              }
              that.uploadList.push(param);
            }
          }
          let list = res.data.obj;
          let type = list.remark;
          that.tittle = list.tittle;
          that.keyWord = list.keyWord;
          document.getElementById('parent').innerHTML="";
          if (list.content) {
            let newMsg = list.content;
            let reg = new RegExp('<img', 'g')//g代表全部
            let content = newMsg.replace(reg, '<el-image');
            let count = 0;
            let index = content.indexOf("<el-image");
            while (index != -1) {
              count++;
              let newContent = content.substring(index, content.length);

              let indexOne = newContent.indexOf("src=\"");
              let indexTwo = newContent.indexOf("\"",indexOne+5);
              let paramUrl = newContent.substring(indexOne + 5, indexTwo);
              let indexThree = newContent.indexOf(">",indexTwo+1);

              content = content.substring(0, index + 9) + " :preview-src-list=\"['"+paramUrl+"']\" src=\"" + paramUrl + "\" "+newContent.substring(indexTwo + 1, indexThree)+"/>" + newContent.substring(indexThree+1, content.length);
              index = content.indexOf("<el-image", index + 68);
            }
            content = "<div>"+content+"</div>";
            let MyComponent = Vue.extend({
              template: content,
              data() {
                return {
                }
              }
            });
            let component = new MyComponent().$mount();
            document.getElementById('parent').appendChild(component.$el);
          }
          // if(list.content){
          //   let content = list.content;
          //   let count = 0;
          //   let index = content.indexOf("<img");
          //   while (index != -1) {
          //     count++;
          //     content = content.substring(0, index+4)+" @on-click=\"showBigPicture\" " + content.substring(index+4, content.length);
          //     index = content.indexOf("<img", index + 28);
          //   }
          //   let MyComponent = Vue.extend({
          //     template: content,
          //   })
          //   let component=new MyComponent().$mount();
          //   document.getElementById('parent').appendChild(component.$el);
          // }
          that.remark = list.remark;
          that.isCollect = list.collect;
        });
      },
    },
    created() {
      this.downName = "";
      this.fileUrl = "";
      this.tittle = "";
      this.content = "";
      this.remark = "";
      this.isCollect = "";
      this.description = "";
      this.uploadList = [];
      this.screenHeight.height = this.mountHeight(290);
      this.initSearch();
    },
    destroyed() {
      this.downName = "";
      this.fileUrl = "";
      this.tittle = "";
      this.content = "";
      this.remark = "";
      this.isCollect = "";
      this.description = "";
      this.uploadList = [];
    },
    watch: {
      knowLookId:function(){
        this.initSearch();
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/knowledgeBase/ViewknowContent.vue